import React, { useState } from "react";
import VelkieLayout from "./VelkieLayout";
import GameMenu from "./GameMenu";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import SearchWrapper from "./SearchWrapper";
import NoEvent from "./NoEvent";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import MyFavSelection from "./MyFavSelection";
import BetSlipContext from "../../context/BetSlipContext";
import { useFavoritesLogic } from "../useLogic/useFavoritesLogic";

const FavouriteVelkie = () => {
  const [search, setSearch] = useState(false);
  const setSportsTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSportsTab;
  });
  const sportTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.sportTab;
  });
  const setLimit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLimit;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const defaultStakeLimit = useContextSelector(AuthContext, (ctx) => {
    return ctx.defaultStakeLimit;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const {
    list,
    position,
    loader,
    odds,
    oddsHistory,
    active,
    handleActive,
    addToFavourite,
  } = useFavoritesLogic();
  const navigate = useNavigate();
  return (
    <VelkieLayout>
      <GameMenu setSearch={setSearch} game={sportTab} setGame={setSportsTab} />
      {list?.length > 0 ? (
        <div className="p-2">
          {list?.map((res) => {
            let matchOdds =
              odds[res?.eventId]?.find((item) => {
                return item?.type == "odds";
              })?.data || {};
            let matchOddsOld =
              odds[res?.eventId]?.find((item) => {
                return item?.type == "odds";
              })?.data || {};

            let matchSportBook =
              odds[res?.eventId]
                ?.find((item) => {
                  return item?.type == "sportbook";
                })
                ?.data?.filter((item) => {
                  return item?.betfairEventId == res?.eventId;
                }) || {};

            let getActive = active?.find((obj) => {
              return obj?.eventId == res?.eventId;
            });
            let updatedPosition =
              position?.length > 0
                ? position?.find((obj) => {
                    return obj?.eventId == res?.eventId;
                  }) || {}
                : {};
            return (
              <div data-v-df39b01c className="px-3px mb-2 rounded-lg bg-white">
                <div
                  onClick={() =>
                    navigate(
                      `/match-detail-velki/${res?.eventId}/${res?.marketId}`
                    )
                  }
                  data-v-df39b01c
                  className="py-9px pl-2 relative"
                >
                  <div
                    data-v-df39b01c
                    className="sub-row flex justify-between items-center"
                  >
                    <h2
                      data-v-df39b01c
                      className="leading-tight text-13 break-all"
                    >
                      {res?.eventName}
                    </h2>
                    <div data-v-df39b01c className="flex items-center ml-auto">
                      <div data-v-df39b01c className="flex items-center pr-1">
                        <i
                          data-v-df39b01c
                          className="icon-arrow-down text-12 ml-2 text-black-500 -rotate-90"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {res?.Odds?.length > 0 &&
                  res?.Odds?.map((item) => {
                    let oddsInner =
                      matchOdds?.length > 0
                        ? matchOdds?.find((obj) => {
                            return obj?.mi == item?.marketId;
                          })
                        : {};
                    let OldoddsInner =
                      matchOddsOld?.length > 0
                        ? matchOddsOld?.find((obj) => {
                            return obj?.mi == item?.marketId;
                          })
                        : {};
                    let backOdds =
                      !isEmpty(oddsInner) && oddsInner?.rt?.length > 0
                        ? oddsInner?.rt?.filter((rt) => rt.ib)
                        : [];

                    let layOdds =
                      !isEmpty(oddsInner) && oddsInner?.rt?.length > 0
                        ? oddsInner?.rt?.filter((rt) => !rt.ib)
                        : [];
                    let OldbackOdds =
                      !isEmpty(OldoddsInner) && OldoddsInner?.rt?.length > 0
                        ? OldoddsInner?.rt?.filter((rt) => rt.ib)
                        : [];

                    let OldlayOdds =
                      !isEmpty(OldoddsInner) && OldoddsInner?.rt?.length > 0
                        ? OldoddsInner?.rt?.filter((rt) => !rt.ib)
                        : [];
                    let ms = !isEmpty(oddsInner)
                      ? oddsInner?.ms
                      : item?.totalMatched;
                    let totalMatched = !isEmpty(oddsInner)
                      ? oddsInner?.totalMatched
                      : 0;

                    return (
                      <MyFavSelection
                        active={getActive?.Odds}
                        addToFavioute={addToFavourite}
                        handleActive={handleActive}
                        totalMatched={totalMatched}
                        ms={ms}
                        layOdds={layOdds}
                        backOdds={backOdds}
                        oldBack={OldbackOdds}
                        oldLay={OldlayOdds}
                        OuterObject={res}
                        object={item}
                        betSlipObject={betSlipObject}
                        showBetDialog={showBetDialog}
                        user={user}
                        setShowBetDialog={setShowBetDialog}
                        setBetSlipObject={setBetSlipObject}
                        setToastObject={setToastObject}
                        defaultStakeLimit={defaultStakeLimit}
                        setLimit={setLimit}
                        position={updatedPosition?.betFair || []}
                        profileData={
                          item?.matchSetting?.length > 0
                            ? {
                                ...item,
                                arrayCheck: "details",
                                profile: profileData,
                              }
                            : {
                                ...profileData,
                                arrayCheck: "profile",
                                profile: profileData,
                              }
                        }
                      />
                    );
                  })}
              </div>
            );
          })}
          {/* <div data-v-df39b01c className="px-3px mb-2 rounded-lg bg-white">
            <div data-v-df39b01c className="py-9px pl-2 relative">
              <div
                data-v-df39b01c
                className="sub-row grid justify-between items-center"
              >
                <h2 data-v-df39b01c className="leading-tight text-13 break-all">
                  Bangladesh <span data-v-df39b01c>-</span> Afghanistan
                </h2>
                <div data-v-df39b01c className="flex items-center ml-auto">
                  <div data-v-df39b01c className="flex items-center pr-1">
                    <i
                      data-v-df39b01c
                      className="icon-arrow-down text-12 ml-2 text-black-500 -rotate-90"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div data-v-df39b01c>
              <section>
                <div className="mb-2">
                  <div className="relative h-34px py-1.5 pr-9 pl-2 text-sm text-primary bg-primary rounded-lg cursor-pointer transition-all duration-300 rounded-t-lg rounded-b-none">
                    <div className="flex justify-start items-center text-base text-market-name font-normal">
                      <div className="-ml-2.5 sm:-ml-1 pt-px mb-3px">
                        <div
                          data-v-117db823
                          className="w-8 h-6 flex justify-center items-center"
                          style={{
                            "--b64d5fc0": "0.4363636363636363",
                            "--3cad14f0": "-0.9375rem",
                          }}
                        >
                          <div
                            data-v-117db823
                            className="fave animate bg-star-sprit-black-webp"
                          />
                        </div>
                      </div>
                      <p className="sm:-ml-1 pr-2 h-6">Bookmaker</p>
                    </div>
                    <span className="icon-arrow-down-sencodary absolute right-4 top-3 text-12 text-market-name transition-transform origin-center duration-300 transform rotate-180" />
                  </div>
                  <div className="pt-1 px-1 bg-white rounded-bl-lg rounded-br-lg">
                    <div className="mb-1 flex justify-between items-center">
                      <div className="w-9/12" />
                      <div className="w-4/12 grid gap-0.5 grid-cols-2">
                        <div className="min-w-min text-10 text-global-font-on-light text-center">
                          Back
                        </div>
                        <div className="min-w-min text-10 text-global-font-on-light text-center">
                          Lay
                        </div>
                      </div>
                    </div>
                    <div data-v-d884c596>
                      <div data-v-d884c596 className="relative space-y-px">
                        <div
                          data-v-d884c596
                          className="bookmaker_selection_line"
                        >
                          <div
                            data-v-d884c596
                            className="relative flex justify-start items-center bg-black-100"
                          >
                            <h2
                              data-v-d884c596
                              className="px-2 w-9/12 h-full leading-5 text-13 flex flex-col justify-center break-all"
                            >
                              Bangladesh{" "}
                              <div
                                data-v-d884c596
                                className="text-10 leading-normal flex"
                                data-testid="forecast"
                              ></div>
                            </h2>
                            <div
                              data-v-d884c596
                              className="w-4/12 relative grid grid-cols-2 gap-x-2 bg-bookmaker-market p-1 rounded-md self-start"
                            >
                              <div
                                data-v-754343ce
                                data-v-d884c596
                                className="h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-back-300"
                                title="BACK"
                                betinfoid="4566-BACK"
                              >
                                <h3 data-v-754343ce className="text-15">
                                  204
                                </h3>
                              </div>
                              <div
                                data-v-754343ce
                                data-v-d884c596
                                className="h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-lay-300"
                                title="LAY"
                                betinfoid="4566-LAY"
                              >
                                <h3 data-v-754343ce className="text-15">
                                  211
                                </h3>
                              </div>
                              <div
                                data-v-d884c596
                                className="absolute right-0 top-0 flex justify-center items-center h-full bg-black-700 opacity-80 text-11 text-white rounded-md w-full"
                              >
                                Suspend
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          data-v-d884c596
                          className="bookmaker_selection_line"
                        >
                          <div
                            data-v-d884c596
                            className="relative flex justify-start items-center bg-black-100"
                          >
                            <h2
                              data-v-d884c596
                              className="px-2 w-9/12 h-full leading-5 text-13 flex flex-col justify-center break-all"
                            >
                              Afghanistan{" "}
                              <div
                                data-v-d884c596
                                className="text-10 leading-normal flex"
                                data-testid="forecast"
                              ></div>
                            </h2>
                            <div
                              data-v-d884c596
                              className="w-4/12 relative grid grid-cols-2 gap-x-2 bg-bookmaker-market p-1 rounded-md self-start"
                            >
                              <div
                                data-v-754343ce
                                data-v-d884c596
                                className="h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-back-300"
                                title="BACK"
                                betinfoid="6214-BACK"
                              >
                                <h3 data-v-754343ce className="text-15">
                                  46
                                </h3>
                              </div>
                              <div
                                data-v-754343ce
                                data-v-d884c596
                                className="h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-lay-300"
                                title="LAY"
                                betinfoid="6214-LAY"
                              >
                                <h3 data-v-754343ce className="text-15">
                                  50
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-v-d884c596></div>
                      </div>
                      <div
                        data-v-d884c596
                        className="py-1 flex justify-center items-center"
                      >
                        <div
                          data-v-d884c596
                          className="flex flex-1 justify-end items-center"
                        >
                          <div
                            data-v-d884c596
                            className="flex items-center text-black-600"
                            data-testid="betLimit"
                          >
                            <i className="px-1 mt-0.5 text-14 icon-min-max" />
                            <span className="px-0.5 text-11">min/max</span>
                            <span className="px-1 text-11 font-bold">
                              1/833
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div> */}
        </div>
      ) : (
        <NoEvent />
      )}
      {search && <SearchWrapper setSearch={setSearch} />}
    </VelkieLayout>
  );
};

export default FavouriteVelkie;
